import ClockoutController from '../../core/clockout.controller';
import Inherit from '../../core/inherit';
import LedgerDelegate from './ledger.delegate';

class LedgerController extends Inherit(ClockoutController, LedgerDelegate) {
    async initialize() {
        // Check if user has valid data (not just an empty object)
        if (!this.user || !this.user.access || this.user.access.length === 0) {
            this.navigateLogin();
            return;
        }

        this.setState({ user: this.data.user });
        const ledger = await this.data.fetchLedger();
        this.setState({ ledger, rows: ledger?.transactions, loading: false });
    }
}

export default LedgerController;
